import { render, staticRenderFns } from "./TelegramTabLinks.vue?vue&type=template&id=c40b707c"
import script from "./TelegramTabLinks.vue?vue&type=script&lang=js"
export * from "./TelegramTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports